import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { LegislationPage } from '../../modules/legislation/client/pages/LegislationPage';
import { ElectionsPage } from '../../modules/elections/client/pages/ElectionsPage';
import { PartiesPage } from '../../modules/elections/client/pages/PartiesPage';
import { AgentProfilePage } from '../../modules/agents/client/pages/AgentProfilePage';
import { AgentsDirectoryPage } from '../../modules/agents/client/pages/AgentsDirectoryPage';
import { CapitolMapPage } from '../../modules/government/client/pages/CapitolMapPage';
import { BuildingInteriorPage } from '../../modules/government/client/pages/BuildingInteriorPage';
import { BudgetPage } from '../../modules/government/client/pages/BudgetPage';
import { DivergencePage } from '../../modules/government/client/pages/DivergencePage';
import { WorldPage } from '../../modules/world/client/pages/WorldPage';
import { AdminPage } from '../../modules/admin/client/pages/AdminPage';
import { CalendarPage } from './pages/CalendarPage';
import { ActivityPage } from './pages/ActivityPage';
import { ProfilePage } from '../../modules/admin/client/pages/ProfilePage';
import { PressRoomPage } from '../../modules/press/client/pages/PressRoomPage';
import { CityPage } from '../../modules/city/client/pages/CityPage';
import { ForumPage } from '../../modules/forum/client/pages/ForumPage';
import { ThreadPage } from '../../modules/forum/client/pages/ThreadPage';
import { BillDetailPage } from '../../modules/legislation/client/pages/BillDetailPage';
import { PartyDetailPage } from '../../modules/elections/client/pages/PartyDetailPage';
import { ElectionDetailPage } from '../../modules/elections/client/pages/ElectionDetailPage';
import { LawsPage } from '../../modules/legislation/client/pages/LawsPage';
import { LawDetailPage } from '../../modules/legislation/client/pages/LawDetailPage';
import { CourtPage } from '../../modules/legislation/client/pages/CourtPage';
import { CourtRecordsPage } from '../../modules/legislation/client/pages/CourtRecordsPage';
import { CasePage } from '../../modules/legislation/client/pages/CasePage';
import { ObserverPage } from '../../modules/admin/client/pages/ObserverPage';
import { ResearcherPage } from '../../modules/admin/client/pages/ResearcherPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { CookieConsent } from './components/CookieConsent';
import { setTokenProvider } from './lib/api';

export function App() {
  const { getToken } = useAuth();

  // Wire Clerk's session token into every API request
  useEffect(() => {
    setTokenProvider(() => getToken());
  }, [getToken]);

  return (
    <>
    <Routes>
      <Route path="/observe" element={<ObserverPage />} />
      <Route element={<Layout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/legislation" element={<LegislationPage />} />
        <Route path="/legislation/:id" element={<BillDetailPage />} />
        <Route path="/laws" element={<LawsPage />} />
        <Route path="/laws/:id" element={<LawDetailPage />} />
        <Route path="/court" element={<CourtPage />} />
        <Route path="/court/records" element={<CourtRecordsPage />} />
        <Route path="/court/cases/:id" element={<CasePage />} />
        <Route path="/elections" element={<ElectionsPage />} />
        <Route path="/elections/:id" element={<ElectionDetailPage />} />
        <Route path="/parties" element={<PartiesPage />} />
        <Route path="/parties/:id" element={<PartyDetailPage />} />
        <Route path="/agents" element={<AgentsDirectoryPage />} />
        <Route path="/agents/:id" element={<AgentProfilePage />} />
        <Route path="/capitol-map" element={<CapitolMapPage />} />
        <Route path="/capitol-map/:buildingId" element={<BuildingInteriorPage />} />
        <Route path="/budget" element={<BudgetPage />} />
        <Route path="/divergence" element={<DivergencePage />} />
        <Route path="/world" element={<WorldPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/press" element={<PressRoomPage />} />
        <Route path="/city" element={<CityPage />} />
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/forum" element={<ForumPage />} />
        <Route path="/forum/:threadId" element={<ThreadPage />} />
        <Route path="/researcher" element={<ResearcherPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
    <CookieConsent />
    </>
  );
}
